import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import SoftBox from "components/SoftBox";
import { useAuth0 } from "@auth0/auth0-react";
import ComplexProjectCard from "cxfcomponents/Cards/ProjectCards/ComplexProjectCard";

function TileView({ data, groupBy, onFlowClick }) {
  const { user } = useAuth0();
  const [isGrouped, setIsGrouped] = useState(null);

  useEffect(() => {
    setIsGrouped(groupBy.some((item) => item !== undefined));
  }, [groupBy]);

  if (isGrouped === null) {
    return;
  }

  return (
    <SoftBox
      display="grid"
      sx={{
        gridTemplateColumns: "repeat(auto-fill, minmax(410px, 1fr))",
        gap: 1,
        justifyContent: "start",
        alignItems: "stretch",
        mb: 2
      }}
    >
      {data.map((row) => (
        <ComplexProjectCard
          key={row.original.flowId}
          tenant_id={user.stripeId}
          flow_id={row.original.flowId}
          title={row.original.name}
          description={row.original.description}
          dateTime={row.original.lastEdited}
          members={row.original.users}
          status={row.original.status}
          actionElement={row.original.action}
          publishStatus={row.original.publishStatus}
          icon={row.original.icon}
          sharedStatus={row.original.sharedStatus}
          onFlowClick={onFlowClick}
        />
      ))}
    </SoftBox>
  );
}

TileView.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  onFlowClick: PropTypes.func,
};

export default TileView;
